import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

/** Activar solo para depurar creación de factura en desarrollo. */
const DEBUG_CREAR_FACTURA = false;
const facturaDebug = (...args) => {
    if (DEBUG_CREAR_FACTURA) console.log(...args);
};
const facturaDebugErr = (...args) => {
    if (DEBUG_CREAR_FACTURA) console.error(...args);
};

/** En false: no se muestra el JSON enviado ni el botón "Ver JSON (Debug)" (producción). Poner true solo para pruebas locales. */
const DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA = false;

function CrearFactura() {
    const location = useLocation();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');
    
    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');
    
    // Modal verificar datos paciente
    const [showModalVerificar, setShowModalVerificar] = useState(false);
    const [datosVerificar, setDatosVerificar] = useState({});
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalDescuento, setTotalDescuento] = useState(0);
    const [totalIVA, setTotalIVA] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [buscarServicio, setBuscarServicio] = useState('');
    const [mostrarOpcionesServicio, setMostrarOpcionesServicio] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;
    
    // Modal para mostrar JSON/Errores
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'json', 'error', 'success'
    
    // Modal de carga para envío a DIAN
    const [showModalEnviando, setShowModalEnviando] = useState(false);
    
    // Modal de confirmación para enviar a DIAN
    const [showModalConfirmarDian, setShowModalConfirmarDian] = useState(false);
    const [facturaIdPendiente, setFacturaIdPendiente] = useState(null);

    // Estados para presupuesto activo
    const [presupuestoActivo, setPresupuestoActivo] = useState(null);
    const [presupuestosActivos, setPresupuestosActivos] = useState([]);
    const [saldoDisponible, setSaldoDisponible] = useState(0);
    const [copiarItemsPresupuesto, setCopiarItemsPresupuesto] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear facturas
        const tienePermiso = userdata.up && userdata.up.includes('facturacion');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar parámetros FEV
        axios.get('/parametros-fev?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setParametrosFev(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos')
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                facturaDebug('err:', error);
            });
    }, []);

    // Cargar datos del presupuesto si viene desde ListadoPresupuestos
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const presupuestoId = urlParams.get('presupuesto');
        const pacienteIdUrl = urlParams.get('paciente_id');
        const presupuestoActivoId = urlParams.get('presupuesto_activo');
        
        facturaDebug('Presupuesto ID desde URL:', presupuestoId);
        facturaDebug('Paciente ID desde URL:', pacienteIdUrl);
        facturaDebug('Presupuesto Activo ID desde URL:', presupuestoActivoId);
        
        if (presupuestoActivoId && loggedIn) {
            cargarPresupuestoActivoDesdeUrl(presupuestoActivoId);
        } else if (presupuestoId && loggedIn) {
            cargarDatosPresupuesto({ id: presupuestoId });
        } else if (pacienteIdUrl && loggedIn) {
            cargarDatosPaciente(pacienteIdUrl);
        }
    }, [location.search, loggedIn]);

    const cargarDatosPresupuesto = async (presupuesto) => {
        facturaDebug('Iniciando carga de presupuesto ID:', presupuesto.id);
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            // Cargar presupuesto completo
            const response = await axios.get(`/presupuesto/${presupuesto.id}?uid=${userdata.user_id}`);
            const presupuestoData = response.data;
            facturaDebug('Presupuesto completo:', presupuestoData);
            
            // Cargar datos del paciente
            const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuestoData.paciente_id}`);
            const pacienteData = pacienteResponse.data[0];
            
            // Establecer datos del paciente
            const nombreCompleto = `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim();
            
            // El ID del paciente viene del presupuesto, no del objeto paciente
            const pacienteId = presupuestoData.paciente_id;
            
            setPacienteId(pacienteId);
            setNombrePaciente(nombreCompleto);
            setTipoPaciente(pacienteData.tipo_documento || 'CC');
            setDocumentoPaciente(pacienteData.numero_documento || '');
            setCodigoResponsabilidad(pacienteData.codigo_responsabilidad || 'No responsable');
            setCodigoRegimen(pacienteData.codigo_regimen || 'No responsable de IVA');
            setCodigoImpuesto(pacienteData.codigo_impuesto || 'No causa');
            
            // Establecer profesional y forma de pago
            setProfesional(presupuestoData.users_id);
            setMetodoPago(presupuestoData.forma_pago === 'Efectivo' ? '10' : '42');
            
            // Cargar productos del presupuesto
            if (presupuestoData.detalle) {
                const productosPresupuesto = presupuestoData.detalle.map(item => ({
                    id: Date.now() + Math.random(),
                    id_listadeprecios: item.id_listadeprecios,
                    codigo: item.lista_precio?.codigo || item.codigo,
                    clasificacion: item.lista_precio?.clasificacion || '',
                    descripcion: item.lista_precio?.nombre || item.nombre,
                    cantidad: item.cantidad,
                    precio: parseFloat(item.precio_unitario),
                    porcentaje: parseFloat(item.porcentaje),
                    impuesto: parseFloat(item.impuesto),
                    total: parseFloat(item.total)
                }));
                
                setProductos(productosPresupuesto);
                calcularTotales(productosPresupuesto);
            }
            
        } catch (error) {
            facturaDebugErr('Error al cargar presupuesto:', error);
        }
    };

    const cargarDatosPaciente = async (pacienteIdParam) => {
        facturaDebug('Cargando datos del paciente ID:', pacienteIdParam);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            // Cargar datos del paciente
            const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteIdParam}`);
            const pacienteData = pacienteResponse.data[0];
            
            if (pacienteData) {
                // Establecer datos del paciente
                const nombreCompleto = `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim();
                
                setPacienteId(pacienteIdParam);
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(pacienteData.tipo_documento || 'CC');
                setDocumentoPaciente(pacienteData.numero_documento || '');
                setCodigoResponsabilidad(pacienteData.codigo_responsabilidad || 'No responsable');
                setCodigoRegimen(pacienteData.codigo_regimen || 'No responsable de IVA');
                setCodigoImpuesto(pacienteData.codigo_impuesto || 'No causa');
                
                facturaDebug('Datos del paciente cargados:', nombreCompleto);
                
                // Cargar presupuestos activos del paciente
                cargarPresupuestosActivos(pacienteIdParam);
            }
        } catch (error) {
            facturaDebugErr('Error al cargar datos del paciente:', error);
        }
    };

    // Cargar presupuestos activos de un paciente
    const cargarPresupuestosActivos = async (pacienteIdParam) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        try {
            const response = await axios.get(`/presupuestos/paciente/${pacienteIdParam}/activos?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setPresupuestosActivos(response.data.presupuestos || []);
                facturaDebug('Presupuestos activos cargados:', response.data.presupuestos?.length || 0);
            }
        } catch (error) {
            facturaDebugErr('Error al cargar presupuestos activos:', error);
            setPresupuestosActivos([]);
        }
    };

    // Precargar presupuesto activo desde URL param (navegación desde EditarPresupuesto)
    const cargarPresupuestoActivoDesdeUrl = async (presupuestoActivoId) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        try {
            // Cargar el presupuesto para obtener el paciente_id
            const response = await axios.get(`/presupuesto/${presupuestoActivoId}?uid=${userdata.user_id}`);
            const presupuestoData = response.data;
            
            if (presupuestoData && presupuestoData.paciente_id) {
                // Cargar datos del paciente
                await cargarDatosPaciente(presupuestoData.paciente_id);
                // Cargar presupuestos activos del paciente
                await cargarPresupuestosActivos(presupuestoData.paciente_id);
                
                // Seleccionar automáticamente el presupuesto activo
                if (presupuestoData.estado === 1) {
                    setPresupuestoActivo(presupuestoData);
                    setSaldoDisponible(parseFloat(presupuestoData.saldo_disponible) || 0);
                }
            }
        } catch (error) {
            facturaDebugErr('Error al cargar presupuesto activo desde URL:', error);
        }
    };

    // Manejar selección de presupuesto activo del dropdown
    const handleSeleccionPresupuestoActivo = async (e) => {
        const selectedId = e.target.value;
        if (!selectedId) {
            setPresupuestoActivo(null);
            setSaldoDisponible(0);
            setCopiarItemsPresupuesto(false);
            return;
        }
        
        const selected = presupuestosActivos.find(p => p.id == selectedId);
        if (selected) {
            setPresupuestoActivo(selected);
            setSaldoDisponible(parseFloat(selected.saldo_disponible) || 0);
            setCopiarItemsPresupuesto(false);
        }
    };

    // Copiar ítems del presupuesto activo seleccionado
    const copiarItemsDePresupuesto = async () => {
        if (!presupuestoActivo) return;
        
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        try {
            const response = await axios.get(`/presupuesto/${presupuestoActivo.id}?uid=${userdata.user_id}`);
            const presupuestoData = response.data;
            
            if (presupuestoData && presupuestoData.detalle) {
                const productosPresupuesto = presupuestoData.detalle.map(item => ({
                    id: Date.now() + Math.random(),
                    id_listadeprecios: item.id_listadeprecios,
                    codigo: item.lista_precio?.codigo || item.codigo,
                    clasificacion: item.lista_precio?.clasificacion || '',
                    descripcion: item.lista_precio?.nombre || item.nombre,
                    cantidad: item.cantidad,
                    precio: parseFloat(item.precio_unitario),
                    porcentaje: parseFloat(item.porcentaje),
                    impuesto: parseFloat(item.impuesto),
                    total: parseFloat(item.total)
                }));
                
                setProductos(productosPresupuesto);
                calcularTotales(productosPresupuesto);
                setCopiarItemsPresupuesto(true);
            }
        } catch (error) {
            facturaDebugErr('Error al copiar ítems del presupuesto:', error);
            alert('Error al cargar los ítems del presupuesto');
        }
    };

    const handlePrefijoChange = (e) => {
        const selectedPrefijo = getPrefijosFiltrados().find(p => p.id == e.target.value);
        setPrefijo(e.target.value);
        if (selectedPrefijo) {
            setNumeroFactura(selectedPrefijo.numero_factura);
        }
    };

    const getPrefijosFiltrados = () => {
        return parametrosFev.filter(param => 
            param.tipo === 'Factura Electronica' && 
            param.users_id == profesional &&
            param.estado == 1
        );
    };

    const getClasificacionesDinamicas = () => {
        const clasificaciones = Array.from(
            new Set(
                listaPrecios
                    .map(item => (item.clasificacion || '').trim())
                    .filter(Boolean)
            )
        );
        return clasificaciones.sort((a, b) => a.localeCompare(b));
    };

    const getListaPreciosFiltrada = () => {
        let filtrada = listaPrecios;

        if (clasificacionFiltro) {
            filtrada = filtrada.filter(item => item.clasificacion === clasificacionFiltro);
        }

        if (buscarServicio.trim()) {
            const term = buscarServicio.toLowerCase();
            filtrada = filtrada.filter(item =>
                (item.nombre || '').toLowerCase().includes(term) ||
                (item.codigo || '').toLowerCase().includes(term)
            );
        }

        return filtrada;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
            setBuscarServicio('');
            setMostrarOpcionesServicio(false);
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                
                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const baseConDescuento = precioBase - descuento;
            const impuesto = baseConDescuento * (producto.impuesto / 100);

            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += producto.total;
        });

        setTotalBruto(subtotal);
        setTotalDescuento(totalDescuentos);
        setTotalIVA(totalImpuestos);
        setTotalPagar(total);
    };

    const abrirModalVerificar = async () => {
        if (!pacienteId) {
            alert('Seleccione un paciente primero');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteId}`);
            setDatosVerificar(response.data[0]);
            setShowModalVerificar(true);
        } catch (error) {
            alert('Error al cargar datos del paciente');
        }
    };

    const actualizarPaciente = async () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            await axios.put('/paciente', datosVerificar);
            alert('Datos del paciente actualizados');
            setShowModalVerificar(false);
        } catch (error) {
            alert('Error al actualizar datos del paciente');
        }
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;
        
        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();
            
            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setCodigoResponsabilidad(paciente.codigo_responsabilidad || 'No responsable');
        setCodigoRegimen(paciente.codigo_regimen || 'No responsable de IVA');
        setCodigoImpuesto(paciente.codigo_impuesto || 'No causa');
        setShowModalPaciente(false);
        
        // Limpiar presupuesto activo anterior y cargar los del nuevo paciente
        setPresupuestoActivo(null);
        setSaldoDisponible(0);
        setCopiarItemsPresupuesto(false);
        cargarPresupuestosActivos(paciente.id);
    };

    const verJsonPreview = async (facturaId = null) => {
        // Si no hay facturaId, validar que haya datos mínimos
        if (!facturaId) {
            if (!pacienteId) {
                alert('Por favor seleccione un paciente primero');
                return;
            }
            
            if (productos.length === 0) {
                alert('Debe agregar al menos un servicio');
                return;
            }

            // Construir el JSON del formulario (datos de entrada)
            const facturaPreview = {
                parametrosfev_id: parseInt(prefijo),
                users_id: parseInt(profesional),
                paciente_id: parseInt(pacienteId),
                fecha_emision: fecha,
                fecha_vence: vencimiento,
                numero_factura: numeroFactura,
                forma_pago: metodoPago,
                tipo_pago: tipoPago,
                valor_bruto: parseFloat(totalBruto),
                valor_total: parseFloat(totalPagar),
                observaciones: observaciones || '',
                codigo_responsabilidad: codigoResponsabilidad,
                codigo_regimen: codigoRegimen,
                codigo_impuesto: codigoImpuesto,
                detalle: productos.map(producto => ({
                    id_listadeprecios: parseInt(producto.id_listadeprecios),
                    cantidad: parseInt(producto.cantidad),
                    precio_unitario: parseFloat(producto.precio),
                    porcentaje: parseFloat(producto.porcentaje),
                    impuesto: parseFloat(producto.impuesto),
                    total: parseFloat(producto.total)
                }))
            };

            setDebugType('json');
            setDebugData({
                message: 'Vista previa del JSON del formulario (datos de entrada)',
                subtitle: 'Este es el JSON que se enviará al backend para guardar la factura. Para ver el JSON que se enviará a la DIAN, primero guarde la factura.',
                json: facturaPreview
            });
            setShowModalDebug(true);
        } else {
            // Si hay facturaId, obtener el JSON de la DIAN desde el backend
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

            try {
                const response = await axios.get(`/factura/${facturaId}/generar-json-dian`);
                
                setDebugType('json');
                setDebugData({
                    message: 'JSON que se enviará a la DIAN',
                    subtitle: 'Este es el JSON formateado según las especificaciones de la DIAN',
                    json: response.data
                });
                setShowModalDebug(true);
            } catch (error) {
                facturaDebugErr('Error al generar JSON:', error);
                setDebugType('error');
                setDebugData({
                    message: 'Error al generar JSON para la DIAN',
                    error: error.response?.data?.error,
                    fullError: error.response?.data
                });
                setShowModalDebug(true);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!pacienteId || pacienteId === '' || pacienteId === 0) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        // Validar saldo si hay presupuesto activo seleccionado
        if (presupuestoActivo && totalPagar > saldoDisponible) {
            alert(`El valor de la factura ($${parseFloat(totalPagar).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente del presupuesto ($${parseFloat(saldoDisponible).toLocaleString('es-CO', {minimumFractionDigits: 2})})`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        if (tipoPago === 'credito' && fecha === vencimiento) {
            alert('Para crédito, la fecha de vencimiento debe ser diferente a la fecha del documento');
            return;
        }

        const facturaData = {
            parametrosfev_id: parseInt(prefijo),
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            numero_factura: numeroFactura,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            codigo_responsabilidad: codigoResponsabilidad,
            codigo_regimen: codigoRegimen,
            codigo_impuesto: codigoImpuesto,
            presupuesto_id: presupuestoActivo ? parseInt(presupuestoActivo.id) : null,
            detalle: productos.map(producto => ({
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/factura', facturaData);
            if (response.status === 200 || response.status === 201) {
                const facturaId = response.data.factura_id;
                
                // Guardar el ID de la factura y mostrar modal de confirmación
                setFacturaIdPendiente(facturaId);
                setShowModalConfirmarDian(true);
            }
        } catch (error) {
            facturaDebugErr('Error completo:', error);
            alert('Error al guardar la factura: ' + (error.response?.data?.message || error.message));
        }
    };
    
    // Función para enviar a DIAN después de confirmar
    const confirmarEnvioDian = async () => {
        // Ocultar modal de confirmación
        setShowModalConfirmarDian(false);
        
        // Mostrar modal de carga
        setShowModalEnviando(true);
        
        try {
            const envioResponse = await axios.post(`/factura/${facturaIdPendiente}/enviar-dian`, {}, {
                headers: {
                    'X-Suppress-403-Modal': 'true'
                }
            });
            
            // Ocultar modal de carga
            setShowModalEnviando(false);
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Factura enviada exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid,
                    estado: envioResponse.data.estado,
                    facturaId: facturaIdPendiente
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code,
                    facturaId: facturaIdPendiente
                });
                setShowModalDebug(true);
            }
        } catch (envioError) {
            facturaDebugErr('Error al enviar a DIAN:', envioError);
            
            // Ocultar modal de carga
            setShowModalEnviando(false);
            
            // Mostrar modal de error
            setDebugType('error');
            setDebugData({
                message: envioError.response?.data?.message || envioError.message,
                error: envioError.response?.data?.error,
                response: envioError.response?.data?.response,
                json_enviado: envioError.response?.data?.json_enviado,
                fullError: envioError.response?.data,
                facturaId: facturaIdPendiente
            });
            setShowModalDebug(true);
        }
        
        // Limpiar formulario
        limpiarFormulario();
    };
    
    // Función para no enviar a DIAN
    const cancelarEnvioDian = () => {
        setShowModalConfirmarDian(false);
        alert('Factura guardada como borrador (Estado 0)');
        
        // Limpiar formulario
        limpiarFormulario();
    };
    
    // Función para limpiar el formulario
    const limpiarFormulario = () => {
        setProductos([]);
        setPacienteId('');
        setNombrePaciente('');
        setDocumentoPaciente('');
        setObservaciones('');
        setTotalBruto(0);
        setTotalDescuento(0);
        setTotalIVA(0);
        setTotalPagar(0);
        setPrefijo('');
        setNumeroFactura('');
        setFacturaIdPendiente(null);
        setPresupuestoActivo(null);
        setPresupuestosActivos([]);
        setSaldoDisponible(0);
        setCopiarItemsPresupuesto(false);
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition factura-page">
                <style>{`
                    .factura-page { font-size: 12.5px; }
                    .factura-page .content-header h1 {
                        font-size: 1.9rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .factura-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .factura-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .factura-page .btn { font-size: 0.82rem !important; }
                    .factura-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .factura-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .factura-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .factura-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .factura-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .factura-soft-banner {
                        border-radius: 14px;
                        border: 1px solid rgba(23,162,184,0.20);
                        background: linear-gradient(135deg, rgba(23,162,184,0.08) 0%, rgba(50,58,69,0.04) 100%);
                        padding: 10px 12px;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .factura-soft-alert {
                        border-radius: 12px;
                        border: 1px solid rgba(220,53,69,0.2);
                        background: rgba(220,53,69,0.08);
                        color: #8a2d2d;
                    }
                    .chip-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .chip-filter {
                        border: 1px solid rgba(23,162,184,0.25);
                        background: rgba(23,162,184,0.06);
                        color: #17a2b8;
                        border-radius: 999px;
                        padding: 5px 12px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                    .chip-filter.active {
                        background: #17a2b8;
                        color: #fff;
                        border-color: #17a2b8;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-facturas">Listado de Facturas</Link></li>
                                        <li className="breadcrumb-item active">Crear Factura Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Factura Electronica de Venta</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline factura-soft-card">
                                <div className="card card-info-outline">
                                    <div className="card-header factura-soft-header">
                                        <h5 className="factura-main-title">
                                            <span className="title-icon"><i className="fas fa-file-invoice-dollar"></i></span>
                                            Información de la Factura
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            
                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-user"></i></span>
                                                Información del Paciente
                                            </h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Responsabilidad *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoResponsabilidad}
                                                            onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                            required
                                                        >
                                                            <option>No responsable</option>
                                                            <option>Régimen simple de tributación</option>
                                                            <option>Gran contribuyente</option>
                                                            <option>Autorretenedor</option>
                                                            <option>Agente de retención IVA</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Tipo de Régimen *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoRegimen}
                                                            onChange={(e) => setCodigoRegimen(e.target.value)}
                                                            required
                                                        >
                                                            <option>No responsable de IVA</option>
                                                            <option>Impuesto sobre las ventas / IVA</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Impuesto *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={codigoImpuesto}
                                                            onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                            required
                                                        >
                                                            <option>No causa</option>
                                                            <option>IVA</option>
                                                            <option>INC</option>
                                                            <option>IVA e INC</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-light"
                                                        onClick={abrirModalVerificar}
                                                    >
                                                        <i className="fas fa-user-check"></i> Verificar Datos
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Sección Presupuesto Activo */}
                                            {pacienteId && presupuestosActivos.length > 0 && (
                                                <div className="card card-outline card-success mb-3">
                                                    <div className="card-header py-2">
                                                        <h6 className="mb-0"><i className="fas fa-wallet mr-1"></i> <b>Presupuesto Activo</b></h6>
                                                    </div>
                                                    <div className="card-body py-2">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group mb-2">
                                                                    <label>Seleccionar Presupuesto Activo</label>
                                                                    <select 
                                                                        className="form-control"
                                                                        value={presupuestoActivo ? presupuestoActivo.id : ''}
                                                                        onChange={handleSeleccionPresupuestoActivo}
                                                                    >
                                                                        <option value="">-- Sin presupuesto --</option>
                                                                        {presupuestosActivos.map(p => (
                                                                            <option key={p.id} value={p.id}>
                                                                                #{p.numero_presupuesto || p.id} - Pendiente: ${parseFloat(p.saldo_disponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 d-flex align-items-end mb-2">
                                                                {presupuestoActivo && (
                                                                    <div>
                                                                        <span className="factura-soft-banner">
                                                                            <i className="fas fa-money-bill-wave mr-1"></i>
                                                                            Saldo Pendiente: ${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {presupuestoActivo && (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {!copiarItemsPresupuesto ? (
                                                                        <button 
                                                                            type="button" 
                                                                            className="btn btn-outline-success btn-sm"
                                                                            onClick={copiarItemsDePresupuesto}
                                                                        >
                                                                            <i className="fas fa-copy mr-1"></i> Copiar ítems del presupuesto
                                                                        </button>
                                                                    ) : (
                                                                        <span className="text-success">
                                                                            <i className="fas fa-check-circle mr-1"></i> Ítems copiados del presupuesto
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Validación en tiempo real: total excede saldo */}
                                                        {presupuestoActivo && totalPagar > saldoDisponible && (
                                                            <div className="row mt-2">
                                                                <div className="col-md-12">
                                                                    <div className="alert mb-0 py-2 factura-soft-alert">
                                                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                                                        El valor total de la factura (${parseFloat(totalPagar || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})}) excede el saldo pendiente (${parseFloat(saldoDisponible || 0).toLocaleString('es-CO', {minimumFractionDigits: 2})})
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <hr />

                                            <h5 className="factura-section-title">
                                                <span className="title-icon"><i className="fas fa-receipt"></i></span>
                                                Datos de Factura
                                            </h5>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Fecha del Documento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fecha}
                                                            onChange={(e) => {
                                                                setFecha(e.target.value);
                                                                if (tipoPago === 'contado') {
                                                                    setVencimiento(e.target.value);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo de Pago *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPago}
                                                            onChange={(e) => {
                                                                setTipoPago(e.target.value);
                                                                if (e.target.value === 'contado') {
                                                                    setVencimiento(fecha);
                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option value="contado">Contado</option>
                                                            <option value="credito">Crédito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            disabled={tipoPago === 'contado'}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Prefijo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={prefijo}
                                                            onChange={handlePrefijoChange}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getPrefijosFiltrados().map(p => (
                                                                <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Factura *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={numeroFactura}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>



                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación dinámica */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <div className="chip-row mb-2">
                                                            <button
                                                                type="button"
                                                                className={`chip-filter ${clasificacionFiltro === '' ? 'active' : ''}`}
                                                                onClick={() => setClasificacionFiltro('')}
                                                            >
                                                                Todas
                                                            </button>
                                                            {getClasificacionesDinamicas().map((clas) => (
                                                                <button
                                                                    key={clas}
                                                                    type="button"
                                                                    className={`chip-filter ${clasificacionFiltro === clas ? 'active' : ''}`}
                                                                    onClick={() => setClasificacionFiltro(clas)}
                                                                >
                                                                    {clas}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* Segunda fila: Selector con búsqueda integrada + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar y seleccionar servicio (código o nombre)..."
                                                                value={buscarServicio}
                                                                onFocus={() => setMostrarOpcionesServicio(true)}
                                                                onBlur={() => setTimeout(() => setMostrarOpcionesServicio(false), 150)}
                                                                onChange={(e) => {
                                                                    setBuscarServicio(e.target.value);
                                                                    setProductoSeleccionado('');
                                                                    setMostrarOpcionesServicio(true);
                                                                }}
                                                            />

                                                            {mostrarOpcionesServicio && (
                                                                <div
                                                                    className="shadow-sm"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        zIndex: 1000,
                                                                        width: '100%',
                                                                        maxHeight: '260px',
                                                                        overflowY: 'auto',
                                                                        background: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '10px',
                                                                        marginTop: '4px'
                                                                    }}
                                                                >
                                                                    {getListaPreciosFiltrada().length === 0 ? (
                                                                        <div style={{ padding: '10px 12px', color: '#8c8c8c', fontSize: '0.85rem' }}>
                                                                            No hay servicios para tu búsqueda.
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {getListaPreciosFiltrada().slice(0, 30).map(servicio => (
                                                                                <button
                                                                                    key={servicio.id}
                                                                                    type="button"
                                                                                    onMouseDown={() => {
                                                                                        setProductoSeleccionado(servicio.id);
                                                                                        setBuscarServicio(`${servicio.codigo || ''} - ${servicio.nombre || ''}`.trim());
                                                                                        setMostrarOpcionesServicio(false);
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        width: '100%',
                                                                                        textAlign: 'left',
                                                                                        border: 'none',
                                                                                        background: 'transparent',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #f3f3f3',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <span style={{ fontWeight: 600, color: '#323a45' }}>{servicio.codigo}</span>
                                                                                    <span style={{ color: '#8c8c8c' }}> - {servicio.nombre}</span>
                                                                                </button>
                                                                            ))}
                                                                            {getListaPreciosFiltrada().length > 30 && (
                                                                                <div style={{ padding: '8px 12px', color: '#8c8c8c', fontSize: '0.75rem', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                                                                                    Mostrando 30 de {getListaPreciosFiltrada().length} resultados. Escribe más para refinar.
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                            disabled={!productoSeleccionado}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '12%'}}>Clasificación</th>
                                                            <th style={{width: '25%'}}>Descripción</th>
                                                            <th style={{width: '8%'}}>Cant.</th>
                                                            <th style={{width: '12%'}}>Precio</th>
                                                            <th style={{width: '8%'}}>Desc %</th>
                                                            <th style={{width: '13%'}}>Impuesto</th>
                                                            <th style={{width: '12%'}}>Total</th>
                                                            <th style={{width: '10%'}}>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>{producto.clasificacion || 'N/A'}</td>
                                                                <td style={{fontSize: '14px', padding: '8px'}}>{producto.descripcion}</td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm" 
                                                                        value={parseFloat(producto.total || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr style={{borderTop: '2px solid #dee2e6'}}>
                                                            <td colSpan="6" className="text-right" style={{border: 'none', paddingTop: '15px'}}><strong>Subtotal:</strong></td>
                                                            <td colSpan="2" style={{border: 'none', paddingTop: '15px'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(totalBruto || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Descuento:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(totalDescuento || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>IVA:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(totalIVA || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Total:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(totalPagar || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-info mr-2"
                                                    disabled={presupuestoActivo && totalPagar > saldoDisponible}
                                                >
                                                    <i className="fas fa-save"></i> Guardar Factura
                                                </button>
                                                {DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={verJsonPreview}
                                                    >
                                                        <i className="fas fa-code"></i> Ver JSON (Debug)
                                                    </button>
                                                )}
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaPaciente}
                                            onChange={(e) => {
                                                setBusquedaPaciente(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map((paciente, index) => (
                                                    <tr key={index}>
                                                        <td>{`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}</td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de Confirmación - Enviar a DIAN */}
                {showModalConfirmarDian && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        <i className="fas fa-paper-plane mr-2"></i>Enviar Factura a la DIAN
                                    </h5>
                                    <button type="button" className="close text-white" onClick={cancelarEnvioDian}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-center py-3">
                                        <i className="fas fa-check-circle text-success" style={{fontSize: '3rem'}}></i>
                                        <h5 className="mt-3 mb-3">Factura guardada exitosamente</h5>
                                        <p className="text-muted mb-0">¿Desea enviar esta factura a la DIAN para su validación?</p>
                                        <small className="text-muted">Si selecciona "No", la factura quedará guardada como borrador (Estado 0)</small>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary"
                                        onClick={cancelarEnvioDian}
                                    >
                                        <i className="fas fa-times mr-1"></i> No, guardar como borrador
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-info"
                                        onClick={confirmarEnvioDian}
                                    >
                                        <i className="fas fa-paper-plane mr-1"></i> Sí, enviar a la DIAN
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de Carga - Enviando a DIAN */}
                {showModalEnviando && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body text-center py-5">
                                    <div className="spinner-border text-info mb-3" role="status" style={{width: '3rem', height: '3rem'}}>
                                        <span className="sr-only">Cargando...</span>
                                    </div>
                                    <h4 className="mb-2">Enviando factura a la DIAN</h4>
                                    <p className="text-muted">Por favor espere, este proceso puede tomar unos momentos...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Debug - Mostrar JSON/Errores */}
                {showModalDebug && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className={`modal-header ${debugType === 'success' ? 'bg-info' : 'bg-light'} text-white`}>
                                    <h4 className="modal-title">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                        ) : debugType === 'error' ? (
                                            <><i className="fas fa-exclamation-triangle mr-2"></i>Error al Enviar</>
                                        ) : (
                                            <><i className="fas fa-code mr-2"></i>Vista Previa JSON</>
                                        )}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'json' ? (
                                        DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA ? (
                                            <div>
                                                <div className="alert alert-info">
                                                    <h5><i className="fas fa-code"></i> {debugData?.message}</h5>
                                                    {debugData?.subtitle && <small>{debugData.subtitle}</small>}
                                                </div>
                                                <div className="card border-info">
                                                    <div className="card-header bg-info text-white">
                                                        <strong>JSON</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '500px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData?.json, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-muted mb-0">La vista previa de JSON está desactivada.</p>
                                        )
                                    ) : debugType === 'success' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                            </div>
                                            <div className="card border-info">
                                                <div className="card-header bg-info text-white">
                                                    <strong><i className="fas fa-info-circle mr-2"></i>Detalles de la Respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p><strong>CUFE:</strong> <code style={{fontSize: '0.9em'}}>{debugData?.cufe}</code></p>
                                                    <p><strong>Estado de la Factura:</strong> 
                                                        <span className={`badge ml-2 ${debugData?.estado === 1 ? 'badge-success' : 'badge-info'}`}>
                                                            {debugData?.estado === 1 ? 'Cobrada (Contado)' : 'Por Cobrar (Crédito)'}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    {DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA && (
                                                        <button
                                                            className="btn btn-outline-info mr-2"
                                                            onClick={() => verJsonPreview(debugData.facturaId)}
                                                        >
                                                            <i className="fas fa-code"></i> Ver JSON enviado
                                                        </button>
                                                    )}
                                                    <button 
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                    <button 
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => window.location.href = '/#/listado-facturas'}
                                                    >
                                                        <i className="fas fa-list"></i> Ir al Listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            {/* Mensaje principal sin alert rojo */}
                                            <p className="text-muted mb-3">{debugData?.message}</p>
                                            
                                            {debugData?.response && (
                                                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                                    <h5 className="alert-heading"><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</h5>
                                                    <hr />
                                                    <pre style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        padding: '0',
                                                        margin: '0',
                                                        maxHeight: '300px',
                                                        overflow: 'auto',
                                                        fontSize: '13px',
                                                        fontFamily: 'Consolas, Monaco, "Courier New", monospace',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word',
                                                        color: '#000000ff'
                                                    }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                </div>
                                            )}
                                            
                                            {/* JSON enviado: solo con DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA === true (evitar fugas en producción) */}
                                            {DEBUG_MOSTRAR_JSON_EN_MODAL_FACTURA && debugData?.json_enviado && (
                                                <div className="card mb-3 border-info">
                                                    <div className="card-header bg-info text-white">
                                                        <strong><i className="fas fa-code mr-2"></i>JSON Enviado (Debug)</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '13px',
                                                            fontFamily: 'Consolas, Monaco, "Courier New", monospace',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {/* Botones de navegación para errores */}
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button 
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                    <button 
                                                        className="btn btn-outline-secondary"
                                                        onClick={() => window.location.href = '/#/listado-facturas'}
                                                    >
                                                        <i className="fas fa-list"></i> Ir al Listado
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                    {debugData?.facturaId && (
                                        <>
                                            <button 
                                                type="button" 
                                                className="btn btn-info" 
                                                onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                            >
                                                <i className="fas fa-info-circle"></i> Ver Factura
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn btn-primary" 
                                                onClick={() => window.location.href = '/#/listado-facturas'}
                                            >
                                                <i className="fas fa-list"></i> Ir al Listado
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Verificar Datos Paciente */}
                {showModalVerificar && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Verificar Datos del Paciente</h4>
                                    <button type="button" className="close" onClick={() => setShowModalVerificar(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Primer Nombre:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.primer_nombre || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, primer_nombre: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Segundo Nombre:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.segundo_nombre || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, segundo_nombre: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Primer Apellido:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.primer_apellido || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, primer_apellido: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Segundo Apellido:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.segundo_apellido || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, segundo_apellido: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Tipo Documento:</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.tipo_documento || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, tipo_documento: e.target.value})}
                                                >
                                                    <option value="CC">CC</option>
                                                    <option value="CE">CE</option>
                                                    <option value="PA">PA</option>
                                                    <option value="PE">PE</option>
                                                    <option value="RC">RC</option>
                                                    <option value="TI">TI</option>
                                                    <option value="NIT">NIT</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Número Documento:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.numero_documento || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, numero_documento: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Teléfono:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.telefono || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, telefono: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Celular:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.celular || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, celular: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Email:</label>
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    value={datosVerificar.email || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, email: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h6><strong>Domicilio</strong></h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Dirección:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.direccion || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, direccion: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>País de Residencia:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.nombre_pais_residencia || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, nombre_pais_residencia: e.target.value})}
                                                    placeholder="Nombre del país"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Municipio de Residencia:</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={datosVerificar.nombre_ciudad_residencia || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, nombre_ciudad_residencia: e.target.value})}
                                                    placeholder="Nombre del municipio"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Zona:</label>
                                                <select 
                                                    className="form-control" 
                                                    value={datosVerificar.zona || ''}
                                                    onChange={(e) => setDatosVerificar({...datosVerificar, zona: e.target.value})}
                                                >
                                                    <option value="">Seleccionar</option>
                                                    <option value="02">URBANO</option>
                                                    <option value="01">RURAL</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalVerificar(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-primary" onClick={actualizarPaciente}>Actualizar Datos</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default CrearFactura;